// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card-module--Card--VK6eT","CardHeader":"Card-module--CardHeader--3KsiT","CardBody":"Card-module--CardBody--drS_r"};